// Persistent user settings keyed by string. Lives behind a Storage seam so
// tests don't need a real localStorage and the future Settings menu has a
// stable interface to consume.

const STORAGE_PREFIX = 'cool-surf:'

export interface NumberSetting {
  readonly key: string
  readonly min: number
  readonly max: number
  readonly default: number
}

export const SENSITIVITY: NumberSetting = {
  key: 'sensitivity',
  min: 0.1,
  max: 10,
  default: 2.5,
}

export class SettingsStore {
  constructor(private readonly storage: Storage = localStorage) {}

  loadNumber(setting: NumberSetting): number {
    let raw: string | null
    try {
      raw = this.storage.getItem(STORAGE_PREFIX + setting.key)
    } catch {
      return setting.default
    }
    if (raw == null) return setting.default
    return clampNumber(parseFloat(raw), setting)
  }

  saveNumber(setting: NumberSetting, value: number): number {
    const clamped = clampNumber(value, setting)
    try {
      this.storage.setItem(STORAGE_PREFIX + setting.key, String(clamped))
    } catch {
      // storage may be unavailable (private mode, quota, …); the in-memory
      // value we return is still useful to callers.
    }
    return clamped
  }
}

function clampNumber(v: number, s: NumberSetting): number {
  if (!Number.isFinite(v)) return s.default
  return Math.min(s.max, Math.max(s.min, v))
}
